import { render } from "./ProBanner.vue?vue&type=template&id=56ea080e"
import script from "./ProBanner.vue?vue&type=script&lang=js"
export * from "./ProBanner.vue?vue&type=script&lang=js"

import "@/assets/css/app.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__